import type { Tenant } from '@shared/types/Tenant';

const PERIODE_RE = /^\d{4}-\d{2}$/;

/** Période paie courante du tenant (AAAA-MM), avec repli sur aujourd'hui ou une liste existante. */
export function periodeCouranteFromTenant(
  tenant: Pick<Tenant, 'periode_courante'> | null | undefined,
  opts?: { periodes?: readonly string[]; fallback?: string },
): string {
  const candidate = tenant?.periode_courante?.trim();
  if (candidate && PERIODE_RE.test(candidate)) {
    if (!opts?.periodes?.length || opts.periodes.includes(candidate)) return candidate;
  }
  if (opts?.periodes?.length) return opts.periodes[0]!;
  return opts?.fallback ?? new Date().toISOString().slice(0, 7);
}
